import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../assets/images/Branding/LOGO1.png";
const Data = [
  {
    title: "الصفحة الرئيسية",
    link: "/",
  },
   {
    title: "السيرة الذاتية",
    link: "/portfolio",
  }, 
  {
    title: "الحملة الاعلامية",
    link: "/media",
  },
  {
    title: "تواصل معنا",
    link: "/contactus",
  },
];

const NavbarComponent = () => {
  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand
          href="https://www.instagram.com/q8.maps/"
          target="_blank"
          style={{ width: "60px", height: "60px" }}
        >
          <img
            src={Logo}
            alt="logo"
            style={{ width: "100%", height: "100%" }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto text-center">
            {Data.map((item, index) => {
              return (
                <Nav.Link
                  key={index}
                  href={item.link}
                  className="mx-3 text-center text-dark"
                >
                  {item.title}
                </Nav.Link>
              );
            })}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
